export default () => ({
  success: false,
  copyText: '',
  successLabel: '',
  defaultLabel: '',
  init() {
    this.copyText = this.$refs.inputCopy.value;
    this.successLabel = this.$refs.button.getAttribute('data-label-success');
    this.defaultLabel = this.$refs.button.getAttribute('data-label-default');
  },
  copy() {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(this.copyText).then(() => {
        this.success = true;
        
        this.$refs.button.innerText = this.successLabel;
        setTimeout(() => {
          this.success = false;
          this.$refs.button.innerText = this.defaultLabel;
        }, 1000);

      });
    } else {
      const textarea = document.createElement('textarea');
      textarea.value = this.copyText;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      this.success = true;

      this.$refs.button.innerText = this.successLabel;
      setTimeout(() => {
        this.success = false;
        this.$refs.button.innerText = this.defaultLabel;
      }, 1000);

    }
  }
});
